import { Routes } from '@angular/router';

export const APP_ROUTES: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('@patient/features/login/login.routes').then(
        (m) => m.LOGIN_ROUTES,
      ),
  },
  {
    path: 'form/:code',
    loadChildren: () =>
      import('@patient/features/login/login.routes').then(
        (m) => m.LOGIN_ROUTES,
      ),
  },
  {
    path: 'confirmation',
    loadChildren: () =>
      import('@patient/features/login/login.routes').then(
        (m) => m.LOGIN_ROUTES,
      ),
  },
  {
    path: 'clinic/:clinicGroupId/home/:homeId',
    loadChildren: () =>
      import('@patient/features/assignments/assignments.routes').then(
        (m) => m.ASSIGNMENTS_ROUTES,
      ),
  },
  {
    path: 'clinic/:clinicGroupId',
    loadChildren: () =>
      import('@patient/features/assignments/assignments.routes').then(
        (m) => m.ASSIGNMENTS_ROUTES,
      ),
  },
  { path: '**', redirectTo: '' },
];
